import React, { useState } from 'react';
import './About.css';

import vendorImg from '../logos/vendor-management-about.jpg';
import trainingImg from '../logos/training-education-about.jpg';
import experienceImg from '../logos/experience-counts-about.jpg';
import dataImg from '../logos/data-analysis-about.png';

const services = [
  {
    title: "Vendor Management",
    description: [
      "Top Tier Benefits will liaise with benefits providers and vendors to coordinate service delivery and resolve any issues or discrepancies. We assist in evaluating and selecting benefits providers when renewing or changing contracts.",
      "We will collaborate with HR and finance teams to assess the effectiveness of benefits programs and provide recommendations for improvements."
    ],
      image: vendorImg,
  },
  {
    title: "Training & Education",
    description:
      "Top Tier Benefits provides training sessions for employees to help them understand the available benefits and how to enroll or make changes. We keep you updated on industry best practices and trends to enhance the benefits of our offerings. ",
    image: trainingImg,
  },
  {
    title: "Experience Counts",
    description:
      "Since 2002, Top Tier Benefits Network has amassed 20+ years of experience. Top Tier Benefits can help ensure compliance with applicable laws and regulations related to employee benefits and help companies stay informed about changes in legislation that impact benefits administration.",
    image: experienceImg,
  },
  {
    title: "Data Analysis",
    description:
      "Top Tier Benefits analyze data related to employee benefits utilization, costs, and trends to insights on program effectiveness and employee engagement. We create and maintain reports that track benefits program performance metrics, such as participation rates and claims data.",
    image: dataImg,
  },
];

const About = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    if (currentIndex < services.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goToPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="about-container">
      {/* Background Section */}
      <div className="about-background"></div>

      <div className="about-subsection">
        <p className="about-text">
          Top Tier Benefits provides assistance and consulting in Benefits Coordination and Administration. This plays a vital role within a company, focusing on the administration and management of employee benefits programs. We help companies manage the day-to-day operations of employee benefits programs.
        </p>
        <p className="about-text">
          We can help provide scripting or assistance for contact with employees regarding benefits inquiries, explaining program offerings and eligibility details.
        </p>
      </div>

      {/* Our Services Section with Partial Next View */}
      <div className="services-section">
        <div className="services-carousel">
          <div className="service-slide active">
            <div className="services-image">
              <img src={services[currentIndex].image} alt={services[currentIndex].title} />
            </div>
            <div className="services-text">
              <h3 className="services-title">{services[currentIndex].title}</h3>
              {/* Handle multi-paragraph vs single-paragraph description */}
              {Array.isArray(services[currentIndex].description) ? (
                services[currentIndex].description.map((para, i) => (
                  <p className="services-description" key={i}>{para}</p>
                ))
              ) : (
                <p className="services-description">{services[currentIndex].description}</p>
              )}
            </div>
          </div>
        </div>


        {/* Arrows BELOW content */}
        <div className="carousel-controls">
          <button
            className={`carousel-arrow ${currentIndex === 0 ? "disabled" : ""}`}
            onClick={goToPrev}
          >
            ←
          </button>
          <button
            className={`carousel-arrow ${
              currentIndex === services.length - 1 ? "disabled" : ""
            }`}
            onClick={goToNext}
          >
            →
          </button>
        </div>
      </div>
      
      {/* Hours Section */}
      <div className="hours-section">
        <div>
          <h1 className="hours-header">OUR OPENING HOURS</h1>
          <p className="hours-text">
            Please feel free to make an appointment with us to get the best service
          </p>
        </div>
        <div className="about-hours">
          <h3 className="about-hours-header">Opening Time</h3>
          <ul className="about-hours-days">
            <li>Mon 9:00am - 5:00pm</li>
            <li>Tue 9:00am - 5:00pm</li>
            <li>Wed 9:00am - 5:00pm</li>
            <li>Thu 9:00am - 5:00pm</li>
            <li>Fri 9:00am - 5:00pm</li>
            <li>Sat Closed</li>
            <li>Sun Closed</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
